import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TermsAndConditionsComponent } from './terms-and-conditions.component';
import { RouterModule, Routes } from '@angular/router';
import { CoreModule } from '@app/core/core.module';
import { MatLegacyCardModule as MatCardModule } from '@angular/material/legacy-card';
import { HeroModule } from '@app/core/components/hero/hero.module';
import { InfoBlockModule } from '@app/core/components/info-block/info-block.module';

const routes: Routes = [
    {
        path: '',
        component: TermsAndConditionsComponent
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class TermsAndConditionsRoutingModule {}

@NgModule({
    declarations: [TermsAndConditionsComponent],
    exports: [TermsAndConditionsComponent],
    imports: [TermsAndConditionsRoutingModule, CommonModule, HeroModule, InfoBlockModule, CoreModule, MatCardModule]
})
export class TermsAndConditionsModule {}
